import * as ambassadorWixSocialGroupsV2GroupRole from './social-groups-v2-group-role-roles.http.js';
import * as ambassadorWixSocialGroupsV2GroupRoleTypes from './social-groups-v2-group-role-roles.types.js';
import * as ambassadorWixSocialGroupsV2GroupRoleUniversalTypes from './social-groups-v2-group-role-roles.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function assignRole(): __PublicMethodMetaInfo<
  'POST',
  { groupId: string },
  ambassadorWixSocialGroupsV2GroupRoleUniversalTypes.AssignRoleRequest,
  ambassadorWixSocialGroupsV2GroupRoleTypes.AssignRoleRequest,
  ambassadorWixSocialGroupsV2GroupRoleUniversalTypes.AssignRoleResponse,
  ambassadorWixSocialGroupsV2GroupRoleTypes.AssignRoleResponse
> {
  const payload = { groupId: ':groupId' } as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2GroupRole.assignRole(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/groups/{groupId}/roles/assign',
    pathParams: { groupId: 'groupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function unassignRole(): __PublicMethodMetaInfo<
  'POST',
  { groupId: string },
  ambassadorWixSocialGroupsV2GroupRoleUniversalTypes.UnassignRoleRequest,
  ambassadorWixSocialGroupsV2GroupRoleTypes.UnassignRoleRequest,
  ambassadorWixSocialGroupsV2GroupRoleUniversalTypes.UnassignRoleResponse,
  ambassadorWixSocialGroupsV2GroupRoleTypes.UnassignRoleResponse
> {
  const payload = { groupId: ':groupId' } as any;

  const getRequestOptions =
    ambassadorWixSocialGroupsV2GroupRole.unassignRole(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v2/groups/{groupId}/roles/unassign',
    pathParams: { groupId: 'groupId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  GroupRole as GroupRoleOriginal,
  Role as RoleOriginal,
  RoleWithLiterals as RoleWithLiteralsOriginal,
  AssignRoleRequest as AssignRoleRequestOriginal,
  AssignRoleResponse as AssignRoleResponseOriginal,
  RoleAssignedToGroupMember as RoleAssignedToGroupMemberOriginal,
  GroupMember as GroupMemberOriginal,
  UnassignRoleRequest as UnassignRoleRequestOriginal,
  UnassignRoleResponse as UnassignRoleResponseOriginal,
  RoleUnassignedFromGroupMember as RoleUnassignedFromGroupMemberOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './social-groups-v2-group-role-roles.types.js';
